<div class="main-content">
  <div class="ui-g component-container" *ngIf="technicianApplication && !submitted">
    <div
      class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align"
      *ngIf="technicianApplication && technicianApplication.status && technicianApplication.status === userStatus['REVOKED']">
      <h4 class="margin-header-align rejection-message text-message-align">{{ technicianApplication.reasonDescription }}</h4>
    </div>

    <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-12 form-column" [formGroup]="companyDataFG">
      <div class="ui-g-12 margin-align">
        <p class="margin-header-align">{{ 'basic-profile.fields.base_data' | translate }}</p>
        <hr />
      </div>

      <div class="ui-g-12 margin-align flex">
        <label for="float-input-steuer" class="ui-g-5">{{ 'basic-profile.fields.tax_id' | translate }}</label>
        <input
          id="float-input-steuer"
          type="text"
          size="30"
          pInputText
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="tax_id"
          (change)="getCompanyDetails()" />
        <div class="ui-g-1">
          <i
            class="pi pi-info-circle hint-icon"
            tooltipStyleClass="netz-info-tooltip"
            pTooltip="{{ 'basic-profile.fields.company-already-registered' | translate }}"></i>
        </div>
      </div>

      <div class="ui-g-12 margin-align">
        <label for="float-input-unternehmen" class="ui-g-5 required">{{ 'basic-profile.fields.company' | translate }}</label>
        <input
          id="float-input-unternehmen"
          type="text"
          size="30"
          pInputText
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="company_name"
          (change)="updateCompany()" />
      </div>

      <div class="ui-g-12 margin-align">
        <label for="float-input-strabe" class="ui-g-5 required">{{ 'basic-profile.fields.street' | translate }}</label>
        <input
          id="float-input-strabe"
          type="text"
          size="30"
          pInputText
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="street"
          (change)="updateCompany()" />
      </div>

      <div class="ui-g-12 margin-align">
        <label for="float-input-hausenummer" class="ui-g-5 required">{{ 'basic-profile.fields.street_number' | translate }}</label>
        <input
          id="float-input-hausenummer"
          type="text"
          size="30"
          pInputText
          maxlength="5"
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="street_number"
          (change)="updateCompany()" />
      </div>

      <div class="ui-g-12 margin-align">
        <label for="float-input-plz" class="ui-g-5 required">{{ 'basic-profile.fields.postcode' | translate }}</label>
        <input
          id="float-input-plz"
          [appNumber]="true"
          size="30"
          pInputText
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="postcode"
          (change)="updateCompany()" />
      </div>

      <div class="ui-g-12 margin-align">
        <label for="float-input-ort" class="ui-g-5 required">{{ 'basic-profile.fields.city' | translate }}</label>
        <input
          id="float-input-ort"
          type="text"
          size="30"
          pInputText
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="city"
          (change)="updateCompany()" />
      </div>

      <div class="ui-g-12 margin-align">
        <label for="float-input-telephone" class="ui-g-5 required">{{ 'basic-profile.fields.telephone_central' | translate }}</label>
        <input
          id="float-input-telephone"
          [appNumber]="true"
          size="30"
          pInputText
          maxlength="50"
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="telephone"
          (change)="updateCompany()" />
      </div>

      <div class="ui-g-12 margin-align">
        <label for="float-input-inhaber" class="ui-g-5 required">{{ 'basic-profile.fields.ceo' | translate }}</label>
        <input
          id="float-input-inhaber"
          type="text"
          size="30"
          pInputText
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="ceo"
          (change)="updateCompany()" />
      </div>

      <div class="ui-g-12 margin-align" *ngIf="showBaseDataEmail">
        <label for="float-input-email" class="ui-g-5 required">{{ 'basic-profile.fields.mail' | translate }}</label>
        <input
          id="float-input-email"
          type="text"
          size="30"
          pInputText
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="email"
          (change)="updateCompany()" />
      </div>

      <div class="ui-g-12 margin-align">
        <label class="ui-g-4"></label>
        <p-radioButton
          name="group"
          value="hauptbetrieb"
          [label]="'basic-profile.fields.headoffice' | translate"
          labelStyleClass="required"
          formControlName="headsubsidiary"
          (onClick)="updateCompany()"></p-radioButton>
      </div>
      <div class="ui-g-12 margin-align">
        <label class="ui-g-4"></label>
        <p-radioButton
          name="group"
          value="nebenbetrieb"
          [label]="'basic-profile.fields.subsidiary' | translate"
          labelStyleClass="required"
          formControlName="headsubsidiary"
          (onClick)="updateCompany()"></p-radioButton>
      </div>
      <div class="ui-g-12 margin-align" *ngIf="showMainBusinessesPartTimeRadioBtn">
        <label class="ui-g-4"></label>
        <p-radioButton
          name="group"
          value="main_businesses_part_time"
          [label]="'basic-profile.fields.main_businesses_part_time' | translate"
          labelStyleClass="required"
          formControlName="headsubsidiary"
          (onClick)="updateCompany()"></p-radioButton>
      </div>
      <div class="ui-g-12 margin-align" *ngIf="showInAuxiliaryOperationRadioBtn">
        <label class="ui-g-4"></label>
        <p-radioButton
          name="group"
          value="in_auxiliary_operation"
          [label]="'basic-profile.fields.in_auxiliary_operation' | translate"
          labelStyleClass="required"
          formControlName="headsubsidiary"
          (onClick)="updateCompany()"></p-radioButton>
      </div>
    </div>

    <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-12 form-column" [formGroup]="technicianDataFG">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <p class="margin-header-align">{{ 'basic-profile.fields.technician-data' | translate }}</p>
        <hr />
      </div>

      <div class="ui-g-12 margin-align">
        <label for="float-input-anrede" class="ui-g-5 required">{{ 'basic-profile.fields.title' | translate }}</label>

        <p-dropdown
          [options]="allTitles"
          formControlName="sk_title"
          id="float-input-anrede"
          (onChange)="updateTechnician()"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'lookup.' + titleKey + '.options.' + item['value'] + '.name' | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">{{ 'lookup.' + titleKey + '.options.' + option['value'] + '.name' | translate }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div class="ui-g-12 margin-align">
        <label for="float-input-varname" class="ui-g-5 required">{{ 'basic-profile.fields.first_name' | translate }}</label>
        <input
          id="float-input-varname"
          type="text"
          size="30"
          pInputText
          maxlength="50"
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="first_name"
          (change)="updateTechnician()" />
      </div>

      <div class="ui-g-12 margin-align">
        <label for="float-input-name" class="ui-g-5 required">{{ 'basic-profile.fields.name' | translate }}</label>
        <input
          id="float-input-name"
          type="text"
          size="30"
          pInputText
          maxlength="50"
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="last_name"
          (change)="updateTechnician()" />
      </div>

      <div class="ui-g-12 margin-align">
        <label for="float-input-geburtsdatum" class="ui-g-5 required">{{ 'basic-profile.fields.birthday' | translate }}</label>
        <p-calendar
          id="float-input-geburtsdatum"
          formControlName="birthday"
          [dateFormat]="dateFormat.dateFormat"
          [placeholder]="dateFormat.placeholder"
          [locale]="'app.calendar-settings' | translate"
          [monthNavigator]="true"
          [yearNavigator]="true"
          yearRange="1900:2080"
          (onClose)="updateTechnician()"></p-calendar>
      </div>

      <div class="ui-g-12 margin-align">
        <label for="float-input-telefon" class="ui-g-5 required">{{ 'basic-profile.fields.telephone_mobile_number' | translate }}</label>
        <input
          id="float-input-telefon"
          [appNumber]="true"
          size="30"
          pInputText
          maxlength="50"
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="telephone"
          (change)="updateTechnician()" />
      </div>

      <!--Api attributes is required to save data in backend-->
      <div class="ui-g-12 margin-align">
        <label for="float-input-masters-examination" class="ui-g-5 required">
          {{ 'basic-profile.fields.masters_examination' | translate }}
        </label>
        <p-dropdown
          [options]="options"
          id="float-input-masters-examination"
          formControlName="qualification_type"
          (onChange)="updateQualificationTechnicianApplication()">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'app.drop_down.' + item['label'] | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">{{ 'app.drop_down.' + option['label'] | translate }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div class="ui-g-12 margin-align" *ngIf="showMastersExaminationOn">
        <label for="float-input-geburtsdatum" class="ui-g-5 required">
          {{ 'basic-profile.fields.masters_examination_on' | translate }}
        </label>
        <p-calendar
          id="float-input-geburtsdatum"
          formControlName="qualification_issued_on"
          [dateFormat]="dateFormat.dateFormat"
          [placeholder]="dateFormat.placeholder"
          [locale]="'app.calendar-settings' | translate"
          [monthNavigator]="true"
          [yearNavigator]="true"
          yearRange="1900:2080"
          (onClose)="updateTechnician()"></p-calendar>
      </div>

      <div class="ui-g-12 margin-align" *ngIf="showTechnicianDataEmail">
        <label for="float-input-technician-email" class="ui-g-5 required">{{ 'basic-profile.fields.mail' | translate }}</label>
        <input
          id="float-input-technician-email"
          type="text"
          size="30"
          pInputText
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="email"
          (change)="updateTechnician()" />
      </div>
    </div>

    <!--Api attributes is required to save data in backend-->
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align margin-top-align">
      <h4 class="margin-header-align text-uppercase required">
        {{ 'overview.details-data.section-titles.network-permissions' | translate }}
      </h4>
      <hr />
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" [formGroup]="checkDataFG">
      <div *ngFor="let commodity of commodities; let i = index">
        <div class="ui-g-3 margin-align">
          <p-checkbox
            id="details-checkbox-{{ i }}"
            [formControlName]="commodity"
            binary="true"
            label="{{ 'overview.details-data.data-rows.' + commodity | translate }}"
            (onChange)="updateTechnician(commodity)"></p-checkbox>
        </div>
      </div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column" *ngIf="enabledRadioButtons()">
        <div class="ui-g-3 margin-align">
          <p-radioButton
            name="license"
            value="withLicense"
            [label]="'basic-profile.fields.with_welding_license' | translate"
            formControlName="license"
            (onClick)="updateTechnician()"></p-radioButton>
        </div>
        <div class="ui-g-3 margin-align">
          <p-radioButton
            name="license"
            value="withoutLicense"
            [label]="'basic-profile.fields.with_out_welding_license' | translate"
            formControlName="license"
            (onClick)="updateTechnician()"></p-radioButton>
        </div>
        <app-file
          *ngIf="enableHeatingWeldingCertificateConfirmation()"
          [documents]="documents"
          [fileType]="'welding_certificate_confirmation_not_required'"
          (fileEvent)="fileEvent()"
          [taId]="taId"
          [uploadDisabled]="companyExist"></app-file>
      </div>
      <div
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column"
        *ngIf="enabledFileUpload() && !enableHeatingWeldingCertificateConfirmation()">
        <app-file
          [documents]="documents"
          [fileType]="'welding_certificate_confirmation'"
          (fileEvent)="fileEvent()"
          [isRequired]="true"
          [taId]="taId"></app-file>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align margin-top-align">
      <h4 class="margin-header-align text-uppercase">{{ 'basic-profile.fields.take_mandatory_documents' | translate }}</h4>
      <hr />
    </div>

    <ng-container *ngFor="let documentType of takeMandatoryDocumentsTypes">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column">
        <app-file
          [documents]="documents"
          [fileType]="documentType"
          (fileEvent)="fileEvent()"
          [isRequired]="!optionalDocumentsTypes.has(documentType)"
          [taId]="taId"
          [uploadDisabled]="companyExist"></app-file>
      </div>
    </ng-container>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align margin-top-align">
      <h4 class="margin-header-align text-uppercase">{{ 'basic-profile.fields.mandatory_documents' | translate }}</h4>
      <hr />
    </div>
    <div
      class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-12 form-column"
      [formGroup]="educationInformationDataFG"
      *ngIf="showEducationInformationSection">
      <div class="ui-g-12 margin-align center-label-field">
        <label for="float-input-journeyman-as" class="ui-g-5">{{ 'basic-profile.fields.journeyman_training_as' | translate }}</label>
        <input
          id="float-input-journeyman-as"
          type="text"
          size="30"
          pInputText
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="journeyman_training_as"
          (change)="updateEducationOnValidators('journeyman_training_as')" />
      </div>

      <div class="ui-g-12 margin-align center-label-field">
        <label for="float-input-diploma-technician" class="ui-g-5">
          {{ 'basic-profile.fields.diploma_technician_specialization' | translate }}
        </label>
        <input
          id="float-input-diploma-technician"
          type="text"
          size="30"
          pInputText
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="diploma_technician_specialization"
          (change)="updateEducationOnValidators('diploma_technician_specialization')" />
      </div>

      <div class="ui-g-12 margin-align center-label-field">
        <label for="float-input-uni-or-tech-college-degree" class="ui-g-5">
          {{ 'basic-profile.fields.university_or_technical_college_degree_specialty' | translate }}
        </label>
        <input
          id="float-input-uni-or-tech-college-degree"
          type="text"
          size="30"
          pInputText
          class="h4-button-and-field ui-input pInputText filed-width"
          formControlName="university_or_technical_college_degree_specialty"
          (change)="updateEducationOnValidators('university_or_technical_college_degree_specialty')" />
      </div>
    </div>

    <div
      class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6 ui-sm-6 ui-xs-12 form-column"
      [formGroup]="educationInformationDataFG"
      *ngIf="showEducationInformationSection">
      <div class="ui-g-12 margin-align center-label-field" *ngIf="educationInformationDataFG.controls.journeyman_training_as.value">
        <label for="float-input-journeyman-on" class="ui-g-5 required">
          {{ 'basic-profile.fields.journeyman_training_on' | translate }}
        </label>
        <p-calendar
          id="float-input-journeyman-on"
          formControlName="journeyman_training_on"
          [dateFormat]="dateFormat.dateFormat"
          [placeholder]="dateFormat.placeholder"
          [locale]="'app.calendar-settings' | translate"
          [monthNavigator]="true"
          [yearNavigator]="true"
          yearRange="1900:2080"
          (onSelect)="updateEducationDateInformation('journeyman_training_on')"></p-calendar>
      </div>

      <div
        class="ui-g-12 margin-align center-label-field"
        *ngIf="educationInformationDataFG.controls.diploma_technician_specialization.value">
        <label for="float-input-diploma-technician-on" class="ui-g-5 required">
          {{ 'basic-profile.fields.diploma_technician_on' | translate }}
        </label>
        <p-calendar
          id="float-input-diploma-technician-on"
          formControlName="diploma_technician_on"
          [dateFormat]="dateFormat.dateFormat"
          [placeholder]="dateFormat.placeholder"
          [locale]="'app.calendar-settings' | translate"
          [monthNavigator]="true"
          [yearNavigator]="true"
          yearRange="1900:2080"
          (onSelect)="updateEducationDateInformation('diploma_technician_on')"></p-calendar>
      </div>

      <div
        class="ui-g-12 margin-align center-label-field"
        *ngIf="educationInformationDataFG.controls.university_or_technical_college_degree_specialty.value">
        <label for="float-input-uni-or-tech-college-degree-on" class="ui-g-5 required">
          {{ 'basic-profile.fields.university_or_technical_college_degree_on' | translate }}
        </label>
        <p-calendar
          id="float-input-uni-or-tech-college-degree-on"
          formControlName="university_or_technical_college_degree_on"
          [dateFormat]="dateFormat.dateFormat"
          [placeholder]="dateFormat.placeholder"
          [locale]="'app.calendar-settings' | translate"
          [monthNavigator]="true"
          [yearNavigator]="true"
          yearRange="1900:2080"
          (onSelect)="updateEducationDateInformation('university_or_technical_college_degree_on')"></p-calendar>
      </div>
    </div>
    <ng-container *ngFor="let documentType of specialistMandatoryDocumentsTypes">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column">
        <app-file
          [documents]="documents"
          [fileType]="documentType"
          (fileEvent)="fileEvent()"
          [isRequired]="!optionalDocumentsTypes.has(documentType)"
          [taId]="taId"></app-file>
      </div>
    </ng-container>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align margin-top-align">
      <h4 class="margin-header-align text-uppercase">{{ 'basic-profile.fields.other_documents' | translate }}</h4>
      <hr />
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column">
      <app-nested-file [taId]="taId" [documents]="documents" (fileEvent)="fileEvent()"></app-nested-file>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column submit-margin margin-top-align">
      <!--<div class="ui-g-5 text-align">
          <h5>{{'basic-profile.fields.policy-left' | translate}}</h5>
      </div>
      <div class="ui-g-5 text-align">
          <h5>{{'basic-profile.fields.policy-right' | translate}}</h5>
      </div>-->
      <div class="ui-g-12 margin-align text-center">
        <button
          pButton
          type="button"
          icon="pi pi-check"
          iconPos="left"
          (click)="saveForm()"
          [disabled]="isSendRequestButtonDisabled()"
          [label]="'basic-profile.fields.send_request' | translate"></button>
      </div>
    </div>
  </div>
  <div class="ui-g component-container" *ngIf="submitted">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
      <h4
        class="margin-header-align text-message-align"
        *ngIf="technicianApplication && technicianApplication.status && technicianApplication.status === userStatus['SUBMITTED']">
        {{ 'basic-profile.fields.application-pending-text' | translate }}
      </h4>
      <h4
        class="margin-header-align text-message-align"
        *ngIf="technicianApplication && technicianApplication.status && technicianApplication.status === userStatus['GRANTED']">
        {{ 'basic-profile.fields.application-granted-text' | translate }}
      </h4>
    </div>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
